import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import RosMark from "@/components/RosMark";

const STAFF_ROLES = ["owner", "provider", "nurse", "front_desk", "system_admin"];

function Loading() {
  // The product's own mark is right here: no clinic has resolved yet, so there is no
  // brand to defer to.
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-3">
      <RosMark size={32} className="animate-pulse" />
      <p className="text-sm text-muted-foreground">Loading…</p>
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role === "patient") return <Navigate to="/portal" replace />;
  return children;
}

export function PatientRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/patient/login" replace />;
  if (STAFF_ROLES.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
